import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const INDUSTRIES = [
  { t: "Financial Services", d: "Risk dashboards, regulatory reporting, fraud analytics for banks, lenders, and insurance carriers.", n: "01" },
  { t: "Manufacturing", d: "OEE dashboards, supply chain visibility, predictive maintenance models on plant data.", n: "02" },
  { t: "Healthcare & Life Sciences", d: "Clinical analytics, patient flow, payer reporting and HIPAA-compliant data platforms.", n: "03" },
  { t: "Retail & E-commerce", d: "Unified customer profiles, attribution, inventory & merchandising intelligence.", n: "04" },
  { t: "Energy & Utilities", d: "Asset performance, ESG reporting, demand forecasting on time-series at scale.", n: "05" },
  { t: "Oil & Gas", d: "Upstream production analytics, well performance, HSE dashboards, and reserves reporting across the value chain.", n: "06" },
  { t: "Public Sector", d: "Citizen services analytics, FedRAMP-aligned architectures, performance accountability dashboards.", n: "07" },
  { t: "Logistics", d: "Last-mile visibility, route optimization, telematics integration for fleet operators.", n: "08" },
  { t: "SaaS & Tech", d: "Product analytics warehouses, ARR/MRR cohorting, embedded analytics in the product.", n: "09" },
  { t: "Education", d: "Student success analytics, enrollment forecasting, and FERPA-aligned reporting for K-12 districts and higher-ed institutions.", n: "10" },
  { t: "Government", d: "Performance dashboards, open data platforms, and grant outcome reporting for federal, state, and municipal agencies.", n: "11" },
  { t: "Environmental Services", d: "Emissions tracking, ESG reporting, waste-stream analytics, and compliance dashboards for sustainability-driven operations.", n: "12" },
  { t: "Legal Services", d: "Matter analytics, billing realization, e-discovery pipelines, and partner-level performance dashboards for law firms.", n: "13" },
  { t: "Construction", d: "Project cost analytics, schedule risk modeling, equipment utilization, and field-to-office data integration for GCs and subcontractors.", n: "14" },
  { t: "Non-Profit NGOs", d: "Donor analytics, grant performance, program impact measurement, and Form 990 reporting for mission-driven organizations.", n: "15" },
];

const Industries = () => (
  <>
    <section className="bg-white text-[#09090b]" data-testid="industries-hero">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-24 pb-20">
        <p className="text-xs tracking-[0.25em] uppercase text-zinc-500 mb-6">Industries</p>
        <h1 className="font-display text-[clamp(2.5rem,7vw,7rem)] leading-[0.9] tracking-tighter">
          Where we <br />operate<span className="text-[#0055FF]">.</span>
        </h1>
        <p className="mt-10 max-w-2xl text-zinc-600 text-lg leading-relaxed">
          Eight regulated and operationally complex sectors where data
          architecture quality compounds into competitive advantage.
        </p>
      </div>
    </section>

    <section className="bg-white text-[#09090b]" data-testid="industries-grid">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-black/10">
          {INDUSTRIES.map((i) => (
            <div
              key={i.n}
              className="p-10 lg:p-14 border-r border-b border-black/10 hover:bg-zinc-50 transition-colors"
              data-testid={`industry-${i.n}`}
            >
              <span className="text-xs tracking-widest text-zinc-400">{i.n}</span>
              <h3 className="font-display text-3xl md:text-4xl tracking-tighter mt-6 mb-4">{i.t}</h3>
              <p className="text-zinc-600 leading-relaxed max-w-md">{i.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="bg-[#0a0a0a] text-white" data-testid="industries-cta">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <h2 className="font-display text-4xl md:text-5xl tracking-tighter">
          Don't see your sector? <span className="text-white/50">We've likely shipped there.</span>
        </h2>
        <Link to="/contact">
          <Button className="bg-[#0055FF] hover:bg-[#0044cc] text-white rounded-none h-12 px-6 font-medium" data-testid="industries-cta-button">
            Talk to an architect
          </Button>
        </Link>
      </div>
    </section>
  </>
);

export default Industries;
